export enum Str {
  InviteRatersParen = 'Portal-InviteRatersParen',
  RemindRatersParen = 'Portal-RemindRatersParen',
  FooterCopyrightPrivacy = 'Portal-FooterCopyrightPrivacy',
  NameAdded = 'Portal-NameAdded',
  ActionsAdded = 'Portal-ActionsAdded',
  RatersNotInvitedWarn = 'Portal-RatersNotInvitedWarn',
  RatersNotSentWarn = 'Portal-RatersNotSentWarn',
  ReportsDelivered = 'Portal-ReportsDelivered',
  ReportsDownloaded = 'Portal-ReportsDownloaded',
  UndeliveredRaters = 'Portal-UndeliveredRaters',
  CustomerServicePhone = 'Portal-CustomerServicePhone',
  FooterPhoneLinks = 'Portal-FooterPhoneLinks',
  CustomerServiceSupportLink = 'Portal-CustomerServiceSupportLink',
  FooterSupportSiteLink = 'Portal-FooterSupportSiteLink',
  CopyrightText = 'Portal-CopyrightText',
  PrivacyText = 'Portal-PrivacyText',
  CopyrightRightsReserved = 'Portal-CopyrightRightsReserved',
  DevPlanAccessMsg = 'Portal-DevPlanAccessMsg',
  Account = 'Portal-Account',
  ActionNumber = 'Portal-ActionNumber',
  Add = 'Portal-Add',
  AddDate = 'Portal-AddDate',
  AddDevItem = 'Portal-AddDevItem',
  AddAction = 'Portal-AddAction',
  AddItem = 'Portal-AddItem',
  AddOptionalText = 'Portal-AddOptionalText',
  AddPreviousRaters = 'Portal-AddPreviousRaters',
  AddRater = 'Portal-AddRater',
  AddCalendar = 'Portal-AddCalendar',
  Added = 'Portal-Added',
  AggregateReport = 'Portal-AggregateReport',
  All = 'Portal-All',
  AllDeliveries = 'Portal-AllDeliveries',
  AnswerRequired = 'Portal-AnswerRequired',
  Answer = 'Portal-Answer',
  AnswerSecurityQuestion = 'Portal-AnswerSecurityQuestion',
  Approval = 'Portal-Approval',
  ApprovalColon = 'Portal-ApprovalColon',
  ApprovalRequestSent = 'Portal-ApprovalRequestSent',
  Approve = 'Portal-Approve',
  ApprovalStatus3 = 'Portal-ApprovalStatus3',
  ApprovalStatus1 = 'Portal-ApprovalStatus1',
  Approver = 'Portal-Approver',
  ApproverColon = 'Portal-ApproverColon',
  RatersNotInvitedConfirm = 'Portal-RatersNotInvitedConfirm',
  AutoRemindersConfirm = 'Portal-AutoRemindersConfirm',
  ConfirmRemind = 'Portal-ConfirmRemind',
  ConfirmRemoveRater = 'Portal-ConfirmRemoveRater',
  ConfirmRemoveItem = 'Portal-ConfirmRemoveItem',
  ConfirmRemoveAction = 'Portal-ConfirmRemoveAction',
  DevPlanReminders = 'Portal-DevPlanReminders',
  Available = 'Portal-Available',
  BackToLogin = 'Portal-BackToLogin',
  Begin = 'Portal-Begin',
  EntryAgreement = 'Portal-EntryAgreement',
  Cancel = 'Portal-Cancel',
  ChangePassword = 'Portal-ChangePassword',
  ChangeSecurityQuestion = 'Portal-ChangeSecurityQuestion',
  ChangePasswordTitle = 'Portal-ChangePasswordTitle',
  ChangeSecurityQuestionTitle = 'Portal-ChangeSecurityQuestionTitle',
  ChooseLanguage = 'Portal-ChooseLanguage',
  ChooseProject = 'Portal-ChooseProject',
  ChooseRater = 'Portal-ChooseRater',
  ChooseSecurityQuestion = 'Portal-ChooseSecurityQuestion',
  ChooseCompetency = 'Portal-ChooseCompetency',
  ChooseCompetencies = 'Portal-ChooseCompetencies',
  Company = 'Portal-Company',
  Competencies = 'Portal-Competencies',
  DashDevPlanItemsMsg = 'Portal-DashDevPlanItemsMsg',
  DashDevPlanItemsEmailMsg = 'Portal-DashDevPlanItemsEmailMsg',
  CompleteBy = 'Portal-CompleteBy',
  Completed = 'Portal-Completed',
  Composite = 'Portal-Composite',
  ConfirmPassword = 'Portal-ConfirmPassword',
  PasswordMismatch = 'Portal-PasswordMismatch',
  DevPlanCompleteMsg = 'Portal-DevPlanCompleteMsg',
  Continue = 'Portal-Continue',
  Copyright = 'Portal-Copyright',
  CreatePassword = 'Portal-CreatePassword',
  CreateASurvey = 'Portal-CreateASurvey',
  CreateDevPlan = 'Portal-CreateDevPlan',
  CreateSurvey = 'Portal-CreateSurvey',
  CurrentPassword = 'Portal-CurrentPassword',
  CustomerService = 'Portal-CustomerService',
  CustomerSupport = 'Portal-CustomerSupport',
  CustomizeEmail = 'Portal-CustomizeEmail',
  CustomizeInvite = 'Portal-CustomizeInvite',
  Dashboard = 'Portal-Dashboard',
  DateDelivered = 'Portal-DateDelivered',
  DateRangeReports = 'Portal-DateRangeReports',
  Days = 'Portal-Days',
  DeadlineColon = 'Portal-DeadlineColon',
  Decline = 'Portal-Decline',
  ApprovalStatus4 = 'Portal-ApprovalStatus4',
  Deliver = 'Portal-Deliver',
  DeliverAll = 'Portal-DeliverAll',
  DeliverSelected = 'Portal-DeliverSelected',
  Delivered = 'Portal-Delivered',
  DeliveredParticipant = 'Portal-DeliveredParticipant',
  DeliveredTo = 'Portal-DeliveredTo',
  Description = 'Portal-Description',
  DescriptionNotAdded = 'Portal-DescriptionNotAdded',
  DevActions = 'Portal-DevActions',
  Devitem = 'Portal-Devitem',
  DevPlan = 'Portal-DevPlan',
  DevResources = 'Portal-DevResources',
  DevTips = 'Portal-DevTips',
  Done = 'Portal-Done',
  Download = 'Portal-Download',
  DownloadAll = 'Portal-DownloadAll',
  DownloadSelected = 'Portal-DownloadSelected',
  DownloadFailed = 'Portal-DownloadFailed',
  EditSurvey = 'Portal-EditSurvey',
  Email = 'Portal-Email',
  EmailColon = 'Portal-EmailColon',
  EmailRater = 'Portal-EmailRater',
  EmailOther = 'Portal-EmailOther',
  EmailPreview = 'Portal-EmailPreview',
  EmailReminders = 'Portal-EmailReminders',
  TemplateMissing = 'Portal-TemplateMissing',
  EmailGoals = 'Portal-EmailGoals',
  EmailPlan = 'Portal-EmailPlan',
  DashDevPlanEmailMsg = 'Portal-DashDevPlanEmailMsg',
  EnterDevItem = 'Portal-EnterDevItem',
  EnterEmail = 'Portal-EnterEmail',
  Expired = 'Portal-Expired',
  AddFailed = 'Portal-AddFailed',
  LoadFailed = 'Portal-LoadFailed',
  SecurityQuestionFather = 'Portal-SecurityQuestion-Father',
  SecurityQuestionColor = 'Portal-SecurityQuestion-Color',
  SecurityQuestionDessert = 'Portal-SecurityQuestion-Dessert',
  FilterParticipant = 'Portal-FilterParticipant',
  FilterProject = 'Portal-FilterProject',
  FirstName = 'Portal-FirstName',
  SecurityQuestionPet = 'Portal-SecurityQuestion-Pet',
  ForgotPassword = 'Portal-ForgotPassword',
  FullReport = 'Portal-FullReport',
  GoalsSentTo = 'Portal-GoalsSentTo',
  Hours = 'Portal-Hours',
  DashDevPlanDoneMsg = 'Portal-DashDevPlanDoneMsg',
  DefaultDevPlanField2 = 'Portal-DefaultDevPlanField2',
  RaterApprovalMsg = 'Portal-RaterApprovalMsg',
  ScoredHigh = 'Portal-ScoredHigh',
  ScoredLow = 'Portal-ScoredLow',
  InProgress = 'Portal-InProgress',
  CreateSurveyFootnote = 'Portal-CreateSurveyFootnote',
  Incomplete = 'Portal-Incomplete',
  InvalidEmail = 'Portal-InvalidEmail',
  LoginFailure = 'Portal-LoginFailure',
  Individual = 'Portal-Individual',
  InviteRemindRaters = 'Portal-InviteRemindRaters',
  InviteRaters = 'Portal-InviteRaters',
  InviteRequirements = 'Portal-InviteRequirements',
  Invited = 'Portal-Invited',
  InvitedColon = 'Portal-InvitedColon',
  InvitesSent = 'Portal-InvitesSent',
  WebReportMsg = 'Portal-WebReportMsg',
  Language = 'Portal-Language',
  LanguageColon = 'Portal-LanguageColon',
  Last3Months = 'Portal-Last3Months',
  Last6Months = 'Portal-Last6Months',
  LastMonth = 'Portal-LastMonth',
  LastName = 'Portal-LastName',
  LastYear = 'Portal-LastYear',
  LogIn = 'Portal-LogIn',
  LogOut = 'Portal-LogOut',
  Minutes = 'Portal-Minutes',
  CustomerServiceHours = 'Portal-CustomerServiceHours',
  SecurityQuestionMother = 'Portal-SecurityQuestion-Mother',
  NA = 'Portal-NA',
  NameColon = 'Portal-NameColon',
  Name = 'Portal-Name',
  NameOrEmail = 'Portal-NameOrEmail',
  NameEmail = 'Portal-NameEmail',
  ApprovalStatus2 = 'Portal-ApprovalStatus2',
  NewPassword = 'Portal-NewPassword',
  SecurityQuestionNickname = 'Portal-SecurityQuestion-Nickname',
  No = 'Portal-No',
  NotAvailable = 'Portal-NotAvailable',
  NotInvited = 'Portal-NotInvited',
  NotStarted = 'Portal-NotStarted',
  NoteForReminders = 'Portal-NoteForReminders',
  Off = 'Portal-Off',
  On = 'Portal-On',
  Online = 'Portal-Online',
  OptionalComments = 'Portal-OptionalComments',
  Or = 'Portal-Or',
  Password = 'Portal-Password',
  PasswordFailsRequirements = 'Portal-PasswordFailsRequirements',
  PasswordRequirements = 'Portal-PasswordRequirements',
  Phone = 'Portal-Phone',
  SelectQuestion = 'Portal-SelectQuestion',
  LoginTitle = 'Portal-LoginTitle',
  Privacy = 'Portal-Privacy',
  PrivacyPolicy = 'Portal-PrivacyPolicy',
  Project = 'Portal-Project',
  Question = 'Portal-Question',
  Questions = 'Portal-Questions',
  RaterApproval = 'Portal-RaterApproval',
  RaterStatus = 'Portal-RaterStatus',
  RecommendedMinimums = 'Portal-RecommendedMinimums',
  Relationship = 'Portal-Relationship',
  RelationshipColon = 'Portal-RelationshipColon',
  RemindRaters = 'Portal-RemindRaters',
  RemindersSent = 'Portal-RemindersSent',
  Remove = 'Portal-Remove',
  ReportPortal = 'Portal-ReportPortal',
  ReportTutorial = 'Portal-ReportTutorial',
  Reports = 'Portal-Reports',
  RequiredMinimums = 'Portal-RequiredMinimums',
  RequiredOpenQuestions = 'Portal-RequiredOpenQuestions',
  Resources = 'Portal-Resources',
  ResponseNotAdded = 'Portal-ResponseNotAdded',
  Retry = 'Portal-Retry',
  Review = 'Portal-Review',
  ReviewDevPlan = 'Portal-ReviewDevPlan',
  ReviewFeedback = 'Portal-ReviewFeedback',
  Save = 'Portal-Save',
  Search = 'Portal-Search',
  SearchDirectory = 'Portal-SearchDirectory',
  SearchParticipants = 'Portal-SearchParticipants',
  SearchProjects = 'Portal-SearchProjects',
  SecurityQuestion = 'Portal-SecurityQuestion',
  Select = 'Portal-Select',
  SelectOne = 'Portal-SelectOne',
  SelfSurvey = 'Portal-SelfSurvey',
  Send = 'Portal-Send',
  SendGoals = 'Portal-SendGoals',
  SendApproval = 'Portal-SendApproval',
  ApproveAllRaters = 'Portal-ApproveAllRaters',
  ConfirmAllRaters = 'Portal-ConfirmAllRaters',
  SendForApproval = 'Portal-SendForApproval',
  SetGoals = 'Portal-SetGoals',
  SetPassword = 'Portal-SetPassword',
  SetSecurityQuestion = 'Portal-SetSecurityQuestion',
  ShowMostRecent = 'Portal-ShowMostRecent',
  Skills = 'Portal-Skills',
  Status = 'Portal-Status',
  Submitted = 'Portal-Submitted',
  Summary = 'Portal-Summary',
  SummaryReport = 'Portal-SummaryReport',
  SurveyDeadline = 'Portal-SurveyDeadline',
  SurveyDeadlineColon = 'Portal-SurveyDeadlineColon',
  TakeSelfSurvey = 'Portal-TakeSelfSurvey',
  IncorrectAnswer = 'Portal-IncorrectAnswer',
  IncorrectPassword = 'Portal-IncorrectPassword',
  SetGoalsDefaultIntro = 'Portal-SetGoalsDefaultIntro',
  ThisMonth = 'Portal-ThisMonth',
  ThisYear = 'Portal-ThisYear',
  Tips = 'Portal-Tips',
  DashInviteMsg = 'Portal-DashInviteMsg',
  Undelivered = 'Portal-Undelivered',
  DevPlanDefaultInstructions = 'Portal-DevPlanDefaultInstructions',
  ViewReport = 'Portal-ViewReport',
  ViewRequirements = 'Portal-ViewRequirements',
  ViewEdit = 'Portal-ViewEdit',
  ViewEditDetails = 'Portal-ViewEditDetails',
  ApprovalStatus5 = 'Portal-ApprovalStatus5',
  DefaultDevPlanField1 = 'Portal-DefaultDevPlanField1',
  DefaultGoal3 = 'Portal-DefaultGoal3',
  DefaultGoal1 = 'Portal-DefaultGoal1',
  WhatToDevelop = 'Portal-WhatToDevelop',
  DefaultDevPlanField3 = 'Portal-DefaultDevPlanField3',
  DefaultGoal2 = 'Portal-DefaultGoal2',
  Yes = 'Portal-Yes',
  DevPlanNumberEmailMsg = 'Portal-DevPlanNumberEmailMsg',
  DevPlanNumberMsg = 'Portal-DevPlanNumberMsg',
  InviteApprovalMsg = 'Portal-InviteApprovalMsg',
  ApproveFor = 'Portal-ApproveFor',
  DashCreateSurveyMsg = 'Portal-DashCreateSurveyMsg',
  DevPlanEmailMsg = 'Portal-DevPlanEmailMsg',
  InviteApprovalMsg2 = 'Portal-InviteApprovalMsg2',
  UninvitedRatersMsg = 'Portal-UninvitedRatersMsg',
  MaxRatersMsg = 'Portal-MaxRatersMsg',
  NoProjects = 'Portal-NoProjects',
  PasswordRestrictDays = 'Portal-PasswordRestrictDays',
  PasswordLastX = 'Portal-PasswordLastX',
  RequiredRatersApprovalMsg = 'Portal-RequiredRatersApprovalMsg',
  RequiredRatersInviteMsg = 'Portal-RequiredRatersInviteMsg',
  AccountLocked = 'Portal-AccountLocked',
  AutoRemindersWarn = 'Portal-AutoRemindersWarn',
  YourSurvey = 'Portal-YourSurvey',
  SurveyCreated = 'Portal-SurveyCreated',
  SurveyFinal = 'Portal-SurveyFinal',
  TempPasswordSent = 'Portal-TempPasswordSent',
  DashMakingProgressMsg = 'Portal-DashMakingProgressMsg',
  Pdf = 'Portal-Pdf',
  Type = 'Portal-Type',
  Web = 'Portal-Web',
  SsoFailure = 'Portal-SsoFailure',
  ChooseApprover = 'Portal-ChooseApprover',
  PlanSentTo = 'Portal-PlanSentTo',
  ChooseOne = 'Portal-ChooseOne',
  PermissionMsg = 'Portal-PermissionMsg',
  OpenQuestions = 'Portal-OpenQuestions',
  NoReports = 'Portal-NoReports',
  UnableToProcess = 'Portal-UnableToProcess',
  NameRequired = 'Portal-NameRequired',
  LoadMore = 'Portal-LoadMore',
  NoApprovalParticipants = 'Portal-NoApprovalParticipants',
  ApprovalSent = 'Portal-ApprovalSent',
  RatersNotProcessed = 'Portal-RatersNotProcessed',
  LoginApprovalTitle = 'Portal-LoginApprovalTitle',
  LoginRecipientTitle = 'Portal-LoginRecipientTitle',
  NoRaters = 'Portal-NoRaters',
  UnknownError = 'Portal-UnknownError',
  NoResults = 'Portal-NoResults',
  AddApproveRater = 'Portal-AddApproveRater',
  TimedOutMsg = 'Portal-TimedOutMsg',
  TimeoutMsg = 'Portal-TimeoutMsg',
  Ok = 'Portal-Ok',
  DevPlanContentExists = 'Portal-DevPlanContentExists',
  DevPlanNumberShareMsg = 'Portal-DevPlanNumberShareMsg',
  DevPlanShareMsg = 'Portal-DevPlanShareMsg',
  InviteShare = 'Portal-InviteShare',
  UnreadCommentsMsg = 'Portal-UnreadCommentsMsg',
  ConfirmUnshare = 'Portal-ConfirmUnshare',
  ConfirmShare = 'Portal-ConfirmShare',
  ViewDetails = 'Portal-ViewDetails',
  AssessmentDetail = 'Portal-AssessmentDetail',
  EnterName = 'Portal-EnterName',
  Accepted = 'Portal-Accepted',
  NotAccepted = 'Portal-NotAccepted',
  UnreadComments = 'Portal-UnreadComments',
  You = 'Portal-You',
  DateNotAdded = 'Portal-DateNotAdded',
  Comments = 'Portal-Comments',
  Other = 'Portal-Other',
  InviteSent = 'Portal-InviteSent',
  SharePlan = 'Portal-SharePlan',
  RequireSymbol = 'Portal-RequireSymbol',
  RestrictPI = 'Portal-RestrictPI',
  InviteApprovalMsg3 = 'Portal-InviteApprovalMsg3',
  Share = 'Portal-Share',
  ShareScores = 'Portal-ShareScores',
  ScoresSent = 'Portal-ScoresSent',
  Generating = 'Portal-Generating',
  Redeliver = 'Portal-Redeliver',
  EnterComment = 'Portal-EnterComment',
  EBook = 'Portal-EBook',
  EBookAvailability = 'Portal-EBookAvailability',
  ECourse = 'Portal-ECourse',
  ECourseRegistrationFailed = 'Portal-ECourseRegistrationFailed',
  ECoursePopupMsg = 'Portal-ECoursePopupMsg',
  ReassessmentMsg = 'Portal-ReassessmentMsg',
  RetakeAssessment = 'Portal-RetakeAssessment',
  ReassessmentAreYouSure = 'Portal-ReassessmentAreYouSure',
  LoginAnnouncement = 'Login-Announcement',
  WhoShouldReceive = 'Portal-WhoShouldReceive',
  Participants = 'Portal-Participants',
  ParticipantMsg = 'Portal-ParticipantMsg',
  ThirdParty = 'Portal-ThirdParty',
  ThirdPartyMsg = 'Portal-ThirdPartyMsg',
  DeliverReports = 'Portal-DeliverReports',
  AggregateDashboard = 'Portal-AggregateDashboard',
  ViewAggregateDashboard = 'Portal-ViewAggregateDashboard',
  DashboardLoadMessage = 'Portal-DashboardLoadMessage',
  Assessment = 'Portal-Assessment',
  Coursework = 'Portal-Coursework',
  CourseworkBegin = 'Portal-Coursework-Begin',
  CourseworkContinue = 'Portal-Coursework-Continue',
  CourseworkCompleted = 'Portal-Coursework-Completed',
  SelfReport = 'Portal-SelfReport', 
  CourseCompletionMsg = 'Portal-CourseCompletionMsg', 
  CourseworkAccess = 'Portal-Coursework-Access',
}
